export const EMAIL_PROVIDERS = {
  RESEND: 'resend',
  SMTP: 'smtp',
  GMAIL: 'gmail',  // @deprecated - Kept for backward compatibility, not shown in UI
  MICROSOFT: 'microsoft',  // @deprecated - Kept for backward compatibility, not shown in UI
} as const

export type EmailProvider = typeof EMAIL_PROVIDERS[keyof typeof EMAIL_PROVIDERS]

export const EMAIL_PROVIDER_LABELS = {
  [EMAIL_PROVIDERS.RESEND]: 'Outvoice Platform Email',
  [EMAIL_PROVIDERS.SMTP]: 'SMTP (Eigen e-mailserver)',
  [EMAIL_PROVIDERS.GMAIL]: 'Gmail (Google OAuth)',  // @deprecated
  [EMAIL_PROVIDERS.MICROSOFT]: 'Microsoft (OAuth)',  // @deprecated
}

export const EMAIL_PROVIDER_OPTIONS = Object.entries(EMAIL_PROVIDER_LABELS).map(([value, label]) => ({
  value,
  label,
}))
